import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import { usersApi, IUser as IUserAPI } from "engine/api/users";
import { routes } from "engine/routes";
import { push } from "redux-first-history";

export const getUsers = createAsyncThunk<IUserAPI[], string | undefined>(
  "users/getAll",
  async (role, { rejectWithValue }) => {
    try {
      const { data } = await usersApi.getUsers(role);

      return data;
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const getUserById = createAsyncThunk<IUserAPI, string>(
  "users/getUserById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await usersApi.getUserById(id);

      return data;
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const addUser = createAsyncThunk<any, IUserAPI>(
  "users/addUser",
  async (user, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.addUser(user);

      if (response.status === 200) {
        message.success("User created successfully");
        dispatch(push(routes.dashboard.users().overview));
      }

      return {};
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const updateUser = createAsyncThunk<any, IUserAPI>(
  "users/updateUser",
  async (user, { rejectWithValue }) => {
    try {
      const response = await usersApi.updateUser(user);

      if (response.status === 200) {
        message.success("User updated successfully");
      }

      return {};
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const deleteUsers = createAsyncThunk<any, string[]>(
  "users/deleteUsers",
  async (ids, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.deleteUsers(ids);

      if (response.status === 200) {
        message.success("User(s) removed successfully");
        dispatch(getUsers());
      }

      return {};
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

